<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-alert
                    color="#856404"
                    dark
                    icon="mdi-alert"
                    border="right"
                    text
                    >
                    IMPORTANTE: Para poder optar a una hipoteca Autopromotor tienes que tener el terreno ya pagado, en caso de que no lo tengas, tendrás que aportar una vivienda familiar libre de Cargas.
                </v-alert>
            </v-col>
            <v-col cols=12 sm=6>
                <v-currency-field
                    label="Valor del Terreno o Vivienda Familiar *"
                    outlined
                    placeholder="200.000€"
                    v-model="preScoring.Vivienda.valor_terreno"
                    :rules="[...ruleRequired,...ruleMax100M]"
                    :min="0"
                    append-icon="mdi-currency-eur"
                    hint="Si no conoce el valor introduzca una estimación"
                    persistent-hint
                    dense
                ></v-currency-field>
            </v-col>
            <v-col cols=12 sm=6>
                <v-currency-field
                    label="Valor total de la Obra *"
                    outlined
                    placeholder="200.000€"
                    v-model="preScoring.Vivienda.valor_obra"
                    :rules="[...ruleRequired,...ruleMax100M]"
                    :min="0"
                    append-icon="mdi-currency-eur"
                    hint="Si no conoce el valor introduzca una estimación"
                    persistent-hint
                    dense
                ></v-currency-field>
            </v-col>
            <v-col cols=12 sm=6>
                <v-currency-field
                    label="Aportación de dinero que harás a la Operación *"
                    outlined
                    v-model="preScoring.Titulares.total_dinero_ahorrado"
                    :rules="[...ruleRequired,...ruleMax100M]"
                    :min="0"
                    append-icon="mdi-currency-eur"
                    hint="Recuerda que cuánto mas aportes, tendrás mejores condiciones y más posibilidades de obtener la financiación"
                    persistent-hint
                    dense
                ></v-currency-field>
            </v-col>
            <!-- <v-col cols=12 sm=6>
                <InputCalendar 
                    :model="preScoring.Vivienda.date_keys"
                    label="Fecha entrega de llaves"
                    outlined
                    @setDate="(payload)=>{
                        SET_DATE_KEYS({date:payload});
                    }"
                    sourceFormat="AAAA/MM/DD"
                ></InputCalendar>
            </v-col> -->
            <v-col cols=12 sm=6>
                <v-text-field
                    label="Dirección de la vivienda (si la tiene)"
                    outlined
                    v-model="preScoring.Vivienda.direccion"
                    dense
                ></v-text-field>
            </v-col>
            <v-col cols=12 sm=6>
                <v-autocomplete 
                    label="Comunidad autónoma *"
                    outlined
                    v-model="preScoring.Vivienda.ccaa"
                    :items="commonVars.ccaa"
                    :rules="[...ruleRequired]"
                    item-text="name"
                    item-value="code"
                    dense
                />
            </v-col>
            <v-col cols=12 sm=6>
                <v-text-field
                    label="Código postal"
                    outlined
                    v-model="preScoring.Vivienda.cp"
                    dense
                ></v-text-field>
            </v-col>
        </v-row>

        <!-- Aval -->
        <AvalistaBlock/>
        <v-row>
            <v-col cols=12 sm=12>
                <v-textarea
                    label="Comentario"
                    placeholder='Explícanos los detalles relevantes de tu operación. Cuantos más detalles nos cuentes, más conocimiento de lo que estás buscando y mejores soluciones te propondremos'
                    v-model="preScoring.Vivienda.comentario"
                    outlined
                    dense
                ></v-textarea>
            </v-col>
        </v-row>        
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import rulesMixin from '../../mixins/rulesMixin';
    import AvalistaBlock from '../AvalistaBlock.vue';
    // import InputCalendar from '../../components/InputCalendar';

    export default {
        mixins: [rulesMixin],
        components:{
            // InputCalendar,
            AvalistaBlock
        },
        methods: {
            ...mapMutations([
                'SET_ACTIVE_STEP',
                'SET_DATE_KEYS',
                'SET_VALUE'
            ]),
        },
        computed: {
            ...mapState([
                'preScoring',
                'commonVars',
                'token_id',
                'propertyStatuses',
                'propertyNew'
            ]),
        }

    }
</script>
